// src/components/ProjektSelector.js
// Projekt-Auswahl-Komponente

import React, { useState } from 'react';
import { useProjekt } from '../contexts/ProjektContext';
import { useUser } from '../UserContext';
import './ProjektSelector.css';

const ProjektSelector = () => {
  const { 
    projekte, 
    aktuellesProjekt, 
    setAktuellesProjekt, 
    loading, 
    canSwitch,
    error 
  } = useProjekt();
  
  const { user } = useUser();
  const [isOpen, setIsOpen] = useState(false);

  // Debug: Temporär immer anzeigen
  console.log('ProjektSelector Debug:', { 
    canSwitch, 
    userRole: user?.role, 
    projekteCount: projekte.length,
    aktuellesProjekt: aktuellesProjekt?.name 
  });
  
  // Wenn User nicht zwischen Projekten wechseln darf, nichts anzeigen
  if (!canSwitch) {
    console.log('ProjektSelector: User darf nicht zwischen Projekten wechseln. Role:', user?.role);
    return null;
  }

  // Wenn keine Projekte verfügbar sind
  if (projekte.length === 0 && !loading) {
    return (
      <div className="projekt-selector">
        <div className="projekt-selector-disabled">
          <span>Keine Projekte verfügbar</span>
        </div>
      </div>
    );
  }

  const handleProjektChange = (projekt) => {
    setAktuellesProjekt(projekt);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const getProjektStatusColor = (status) => {
    switch (status) {
      case 'aktiv':
        return '#4CAF50';
      case 'inaktiv':
        return '#f44336';
      default:
        return '#757575';
    }
  };

  return (
    <div className="projekt-selector">
      <div className="projekt-selector-header">
        <span className="projekt-selector-label">Projekt:</span>
        
        {loading ? (
          <div className="projekt-selector-loading">
            <span>Lade Projekte...</span>
          </div>
        ) : (
          <div className="projekt-selector-dropdown">
            <button 
              className="projekt-selector-button"
              onClick={toggleDropdown}
              disabled={projekte.length === 0}
            >
              <div className="projekt-selector-current">
                {aktuellesProjekt ? (
                  <>
                    <span className="projekt-name">{aktuellesProjekt.name}</span>
                    <span 
                      className="projekt-status"
                      style={{ backgroundColor: getProjektStatusColor(aktuellesProjekt.status) }}
                    >
                      {aktuellesProjekt.status}
                    </span>
                  </>
                ) : (
                  <span className="projekt-placeholder">Projekt auswählen</span>
                )}
              </div>
              <span className="projekt-selector-arrow">
                {isOpen ? '▲' : '▼'}
              </span>
            </button>
            
            {isOpen && (
              <div className="projekt-selector-dropdown-menu">
                {projekte.map((projekt) => (
                  <div
                    key={projekt.id}
                    className={`projekt-selector-option ${
                      aktuellesProjekt?.id === projekt.id ? 'selected' : ''
                    }`}
                    onClick={() => handleProjektChange(projekt)}
                  >
                    <span className="projekt-name">{projekt.name}</span>
                    <span 
                      className="projekt-status"
                      style={{ backgroundColor: getProjektStatusColor(projekt.status) }}
                    >
                      {projekt.status}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
      
      {error && (
        <div className="projekt-selector-error">
          <span>Fehler: {error}</span>
        </div>
      )}
    </div>
  );
};

export default ProjektSelector;
